import * as React from 'react';
import { useSelector } from 'react-redux';

import { MortgageOfferRow } from '../../../components/NewbuildingMortgageSection';
import { getOffer } from '../../../selectors/newObject';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { trackClickPromoBlock } from '../../../utils/tracking/promos/trackClickPromoBlock';
import { useApplicationContext } from '../../ApplicationContext';
import { NewbuildingPromoDetailsContainer } from '../../NewbuildingPromoDetails';
import {
  formatMonthlyPayment,
  getInterestRate,
  getMaxCredit,
  getMaxLoanTerm,
  getMortgagePartnerLink,
  getPromoProvider,
} from '../helpers';
import { trackGetOnlineClick } from '../tracking/trackGetOnlineClick';

export interface IMortgageOfferRowContainerProps {
  monthlyPayment?: number;
  position: number;
  promo: IPromoInfo;
}

export const MortgageOfferRowContainer: React.FC<React.PropsWithChildren<IMortgageOfferRowContainerProps>> = ({
  monthlyPayment,
  position,
  promo,
}) => {
  const promoProvider = getPromoProvider(promo);

  const { config } = useApplicationContext();

  const offer = useSelector(getOffer);

  const [isModalOpen, setModal] = React.useState(false);

  const handleRowClick = React.useCallback(() => {
    setModal(true);
    trackClickPromoBlock({ promo, offer });
  }, [promo, offer]);

  const handleGetOnlineClick = React.useCallback(() => {
    trackGetOnlineClick({ promo, offer, position });
  }, [position, promo, offer]);

  const handleModalClosing = React.useCallback(() => setModal(false), []);

  return (
    <>
      <MortgageOfferRow
        interestRate={getInterestRate(promo)}
        isBlackFriday={Boolean(promo.isBlackFriday)}
        maxCredit={getMaxCredit(promo)}
        maxLoanTerm={getMaxLoanTerm(promo)}
        monthlyPayment={formatMonthlyPayment(monthlyPayment)}
        mortgagePartnerLink={getMortgagePartnerLink(promo, config)}
        promoName={promo.name}
        providerLogoUrl={promoProvider.logoUrl}
        providerName={promoProvider.name}
        onClick={handleRowClick}
        onGetOnlineClick={handleGetOnlineClick}
      />
      <NewbuildingPromoDetailsContainer open={isModalOpen} offer={offer} onClose={handleModalClosing} promo={promo} />
    </>
  );
};
